import React from 'react';
import PropTypes from 'prop-types';

import { Plans } from '../../constants';
import { default as PlansComponent } from '@fff-web/fff-ui-shared/Plans';

import { useDecision } from '@optimizely/react-sdk';
import { useGetPricesByPlan } from '../../../utils/hooks';
import { IPlanCode } from '../../../utils/Interfaces';
import { GROWTH_MY_REACTIVATE_MEMBERSHIP } from '../../../utils/Optimizely/featureFlagVariations';

const PlanList = ({ selectedPlan, handlePlanChange }) => {
  const [growthMyMembershipDecision] = useDecision(GROWTH_MY_REACTIVATE_MEMBERSHIP.FEATURE_FLAG);

  const { variables } = growthMyMembershipDecision;
  const seasonalPerkList = variables.seasonalPerks?.list;
  const annualPerkList = variables.annualPerks?.list;
  const { isLoadingPrices, seasonalPrice, annualPrice } = useGetPricesByPlan(
    growthMyMembershipDecision,
  );

  const annualPlanSubtitle = variables?.annualCardSubtitle;

  const annualData = {
    title: 'Annual',
    subtitle: annualPlanSubtitle,
    price: annualPrice?.price,
    isLoadingPrice: isLoadingPrices,
    annualPrice: annualPrice?.annualPrice,
    isSelected: selectedPlan === IPlanCode.ANNUAL,
    onSelectPlan: () => onSelectPlanCode(IPlanCode.ANNUAL),
  };

  const seasonalData = {
    title: 'Seasonal',
    subtitle: 'Pay per box',
    price: seasonalPrice?.price,
    isLoadingPrice: isLoadingPrices,
    disclaimer: 'Billed quarterly.',
    isSelected: selectedPlan === IPlanCode.SEASONAL,
    onSelectPlan: () => onSelectPlanCode(IPlanCode.SEASONAL),
  };

  const onSelectPlanCode = (planCode) => {
    handlePlanChange(planCode);
  };

  return (
    <PlansComponent
      annualData={{
        ...annualData,
        perksList: annualPerkList,
      }}
      seasonalData={{
        ...seasonalData,
        perksList: seasonalPerkList,
      }}
    />
  );
};

PlanList.defaultProps = {
  selectedPlan: Plans.ANNUAL,
};

PlanList.propTypes = {
  selectedPlan: PropTypes.string,
};

export default PlanList;
